export const ANY_NUMBER = -2;
export const NULL_NUMBER = -1;
export const ANY_STRING = 'any';
export const NULL_STRING = 'null';
